module.exports = __webpack_public_path__ + "img/barracuda.c50f1953.jpg";